<template>
    <div class="news-content">
        <div class="news-item" v-for="(item, index) in list" :key="index" @click="goDetail(item.id)">
            <img class="news-img" :src="item.img">
            <p class="title">{{item.title}}</p>
            <p class="des">{{item.des}}</p>
            <div class="operate-box">
                <div class="info-box">
                    <p class="origin">{{item.origin}}</p>
                    <p class="time">{{item.date}}</p>
                </div>
                <p class="detail">查看详情 →</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        goDetail (id) {
            this.$router.push({ name: 'newsDetail', query: { id: id}})
        }
    }
}
</script>
<style lang="scss" scoped>
.news-content{
    width: 100%;
    .news-item{
        text-align: left;
        padding: 20px 20px 18px;
        background:rgba(255,255,255,1);
        box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
        border-radius:6px;
        margin-bottom: 14px;
        .news-img{
            width: 100%;
        }
        .title{
            margin-top: 16px;
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:#282828;
            line-height:24px;
        }
        .des{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#282828;
            line-height:22px;
        }
        .operate-box{
            margin-top: 6px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#999999;
            line-height:24px;
            .info-box{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .origin{
                    margin-right: 10px;
                }
            }
        }
        &:last-of-type{
            margin-bottom: 0px;
        }
    }
}
</style>